export default (val) => val || val === 0;